/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MeterImageDetails } from '../models/MeterImageDetails';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class ImagesVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async imagesVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/images/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns MeterImageDetails OK
     * @throws ApiError
     */
    public static async imagesVGetExport(
        requestBody?: PagingQuery,
    ): Promise<MeterImageDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/images/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param meterImageId
     * @returns MeterImageDetails OK
     * @throws ApiError
     */
    public static async imagesVGetById(
        meterImageId: string,
    ): Promise<MeterImageDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/images/${meterImageId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param meterImageId
     * @returns any OK
     * @throws ApiError
     */
    public static async imagesVDelete(
        meterImageId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/images/${meterImageId}`,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

}